import createLucideIcon from '../createLucideIcon';

const CornerUpLeft = createLucideIcon('CornerUpLeftIcon', [
  ['polyline', { points: '9 14 4 9 9 4', key: '881910' }],
  ['path', { d: 'M20 20v-7a4 4 0 0 0-4-4H4', key: '1nkjon' }],
]);

export default CornerUpLeft;
